import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  text: {
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: 1,
    color: '#7df3e1',
    fontFamily: 'Helvetica, Arial, sans-serif',
  },
  accent: {
    color: '#ffffff',
    fontWeight: 300,
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return (
    <span className={classes.text}>
      Dualy<span className={classes.accent}> Hub</span>
    </span>
  );
};
